import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import MEDIA_QUERY from '../../styles/emotion/mediaQuery';
import SPACING from '../../styles/emotion/spacing';
import COLORS from '../../styles/emotion/colors3';
import ZINDEX from '../../styles/emotion/zIndex';

const openAnimation = keyframes`
  from, 0%, to {
    max-height: 0;
  }
  100%{
    max-height: 100vh;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  bottom: 0;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${ZINDEX.super};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${MEDIA_QUERY.MOBILE} {
    align-items: flex-end;
  }
`;

export const ModalDialog = styled.div<{ squareCorners?: boolean }>`
  background-color: ${COLORS.WHITE_100};
  border-radius: ${SPACING.S24};

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    position: relative;
    /** The modal should always be at least 40px from the bottom of the screen*/
    margin: 40px auto;
  }

  ${MEDIA_QUERY.MOBILE} {
    position: absolute;
    bottom: 0;
    top: auto;
    width: 100%;
    max-height: 100%;
    border-radius: ${(p) => (p.squareCorners ? '0' : `${SPACING.S16} ${SPACING.S16} 0 0`)};
    animation: ${openAnimation} 0.5s ease-in-out;
    margin: auto 0 0 0;
    overflow-y: auto;
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: ${SPACING.XS};
  right: ${SPACING.XS};
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${SPACING.XXS};
  margin: ${SPACING.XXS};
  outline: none;
  border: none;
  background: none;
  color: ${COLORS.BLACK_100};
  &:hover {
    color: ${COLORS.BLACK_075};
    cursor: pointer;
  }
  &:focus {
    outline: highlight auto 2px;
    outline: -webkit-focus-ring-color auto 2px;
  }
  z-index: ${ZINDEX.top};
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
